import RoleRepository from "@common/domain/data/RoleRepository";
import Role from "@common/domain/entities/Role";
import User from "@common/domain/entities/User";

export default class APIRoleRepository implements RoleRepository{
    getRoles(user: User): Promise<Role[]> {
        throw new Error("Method not implemented.");
    }   
}